
import Vue from 'vue'
// import HeaderSearch from '@/components/globalHeader/HeaderSearch.vue'
import { CommonData } from '@/types/commonData'
import { ProductCategory } from '@/model/productCategory'
import eventBus from '@/utils/eventBus'
import { APP_EVENTS } from '@/constants'
import HeaderContact from '@/components/HeaderContact.vue'
import HeaderFlag from '@/components/globalHeader/HeaderFlag.vue'

const MENU_PAGES = {
  MAIN: 'main',
  PARENT_CAT: 'parent_category',
  CHILD_CAT: 'child_category'
}
export default Vue.extend({
  components: {
    HeaderContact,
    HeaderFlag
    // HeaderSearch
  },
  props: {
    commonData: {
      type: Object as () => CommonData,
      required: true
    },
    revisionOrderNumber: {
      type: Number,
      required: true
    }
  },
  data(): {
    activeMenu: string
    MENU_PAGES: {[key: string]: string}
    activeParentCategory: number,
      favoritesCount: number
  } {
    return {
      activeMenu: MENU_PAGES.MAIN,
      MENU_PAGES: MENU_PAGES,
      activeParentCategory: -1,
      favoritesCount: 0
    }
  },
  computed: {
    parentCategories(): ProductCategory[] {
      return this.commonData.product_categories
    },
    childCategories(): ProductCategory[] {
      return this.parentCategories.find(item => item.id === this.activeParentCategory)?.child_categories || []
    }
  },
  created() {
    this.favoritesCount = this.commonData.favorites_count
    eventBus.$on(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, (count: number) => {
      this.favoritesCount = count
    })
  },
  methods: {
    close() {
      this.$emit('close')
    },
    activateMainMenu() {
      this.activeMenu = this.MENU_PAGES.MAIN
    },
    activateParentCategoryMenu() {
      this.activeMenu = this.MENU_PAGES.PARENT_CAT
    },
    onSelectParentCategory(item: ProductCategory) {
      if (item.child_categories && item.child_categories.length > 0) {
        this.activeParentCategory = item.id
        this.activeMenu = this.MENU_PAGES.CHILD_CAT
      } else {
        window.location.href = item.url
      }
    }
  }
})
